import { Avatar, Box, Chip, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SchoolIcon from '@mui/icons-material/School';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import { SUBJECT_OPTIONS } from '../forms/StudentFormDialog';

const B = { primary: '#4357AD', dark: '#1E2A4A' };

const JournalHeader = ({ student, onBack, action }) => {
  if (!student) return null;
  const subjectLabel = SUBJECT_OPTIONS.find((o) => o.value === student.subjects)?.label || student.subjects;

  return (
    <Box
      sx={{
        background: `linear-gradient(135deg, ${B.dark} 0%, ${B.primary} 100%)`,
        borderRadius: 4,
        px: { xs: 1.5, sm: 2, md: 3 },
        py: 2,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'stretch', sm: 'center' },
        justifyContent: 'space-between',
        gap: { xs: 1.5, sm: 2 },
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0 }}>
        <IconButton
          onClick={onBack}
          size="small"
          sx={{
            color: '#fff',
            bgcolor: 'rgba(255,255,255,0.15)',
            borderRadius: 2,
            flexShrink: 0,
            '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' },
          }}
        >
          <ArrowBackIcon fontSize="small" />
        </IconButton>
        <Avatar
          sx={{
            width: { xs: 40, sm: 48 },
            height: { xs: 40, sm: 48 },
            bgcolor: 'rgba(255,255,255,0.2)',
            color: '#fff',
            fontWeight: 700,
            fontSize: { xs: 16, sm: 20 },
            border: '2px solid rgba(255,255,255,0.3)',
            flexShrink: 0,
          }}
        >
          {student.name?.charAt(0)?.toUpperCase()}
        </Avatar>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h6" fontWeight={800} sx={{ color: '#fff', fontSize: { xs: 16, sm: 20 } }} noWrap>
            {student.name}
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Chip
              icon={<SchoolIcon sx={{ fontSize: 14 }} />}
              label={student.grade}
              size="small"
              sx={{
                bgcolor: 'rgba(255,255,255,0.18)',
                color: '#fff',
                fontWeight: 600,
                fontSize: 12,
                height: 22,
                '& .MuiChip-icon': { color: '#fff' },
              }}
            />
            {student.subjects && (
              <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)' }} noWrap>
                {subjectLabel}
              </Typography>
            )}
            {student.archived && (
              <Chip
                icon={<ArchiveOutlinedIcon sx={{ fontSize: 14 }} />}
                label="Архів"
                size="small"
                sx={{
                  bgcolor: 'rgba(254,243,199,0.9)',
                  color: '#92400E',
                  fontWeight: 700,
                  fontSize: 11,
                  height: 22,
                  '& .MuiChip-icon': { color: '#92400E' },
                }}
              />
            )}
          </Stack>
        </Box>
      </Stack>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ flexShrink: 0, justifyContent: { xs: 'flex-end', sm: 'flex-start' } }}>
        {action}
        <Tooltip
          title={
            <Box sx={{ p: 1 }}>
              <Typography variant="body2"><strong>ПІБ:</strong> {student.name}</Typography>
              {student.subjects && <Typography variant="body2"><strong>Предмет:</strong> {subjectLabel}</Typography>}
              <Typography variant="body2"><strong>Репетитор:</strong> {student.tutorName || '—'}</Typography>
            </Box>
          }
          arrow
        >
          <IconButton sx={{ color: 'rgba(255,255,255,0.6)', '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.1)' } }}>
            <InfoOutlinedIcon />
          </IconButton>
        </Tooltip>
      </Stack>
    </Box>
  );
};

export default JournalHeader;
